import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AnimationContainer } from './animatedBooking.styles';
import { Animated } from '../../../shared/components/animated';
import { Theme } from '../../../modules/headerBar/themes';
import Booking from '../booking.container';

export class AnimatedBooking extends PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
    setHeaderTheme: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.handleEnterAnimationFinished();
  }

  handleEnterAnimationFinished = () => {
    this.props.setHeaderTheme(Theme.HIDDEN);
  };

  render() {
    return (
      <Animated visible={this.props.visible} onEntered={this.handleEnterAnimationFinished}>
        <AnimationContainer>
          <Booking />
        </AnimationContainer>
      </Animated>
    );
  }
}
